module.exports = __webpack_public_path__ + "img/inbox.1d536640.svg";